export enum ButtonVariations {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  ICON = 'icon',
  SUCCESS = 'success',
  DANGER = 'danger',
  DANGER_SECONDARY = 'danger-secondary',
  LIST_ITEM = 'list-item',
  BANNER = 'banner',
  BANNER_SECONDARY = 'banner-secondary'
}

export interface VariantBackgroundImage {
  image: string;
  horizontalPosition?: string;
  verticalPosition?: string;
  width?: string;
  height?: string;
}

export interface VariantBackgroundColor {
  color: string;
}

export interface ButtonBackgroundProps {
  background: string;
  hoverBackground: string;
}

export interface ButtonTextProps {
  color: string;
  hoverColor: string;
}

// this is the interface for the component displayed in the right half of the screen (if the variant is split)
export interface SplashProps {
  // background image and props to tweak its placement
  background: {
    image: string;
    horizontalPosition?: string;
    verticalPosition?: string;
    width?: string;
    height?: string;
  };
  paddingX?: string;
  logo?: {
    image: string;
    margin?: string;
    width?: string;
  };
  title: {
    text: string;
    color?: string;
    sizeMobile?: string;
    sizeDesktop?: string;
  };
  subtitle: {
    text: string | React.ReactNode;
    color?: string;
    sizeMobile?: string;
    sizeDesktop?: string;
  };
  textColor?: string;
  // the button at the bottom of the component, under text
  button?: {
    buttonColor?: ButtonBackgroundProps;
    text: string;
    url: string;
    variation?: ButtonVariations;
    fullWidth?: boolean;
    textColor?: ButtonTextProps;
  };
}

export interface VariantProps {
  // a specific name used for segment tracking
  type: string;
  // color of the text
  textColor?: string;
  // background as an image or color code
  background: VariantBackgroundColor | VariantBackgroundImage;
  title: string;
  // title used when the user hasPreferredLogin
  preferredLoginTitle?: string;
  subtitle: string;
  // subtitle used when the user hasPreferredLogin
  preferredLoginSubtitle?: string;
  metadata?: {
    title?: string;
    description?: string;
  };
  // object with props for the right half of the screen
  splash?: SplashProps;
  footerTextColor?: string;
  footerLinkColor?: string;
  weight?: number;
}

interface Image {
  url: string;
}

interface Title {
  text?: string;
  color?: 'dark' | 'light';
}

export type Sizes = 'small' | 'medium' | 'large';

export interface DynamicVariantProps {
  id: number;
  createdAt?: Date;
  updatedAt?: Date;
  publishedAt?: Date;
  type: string;
  loginTitle?: string;
  loginSubtitle?: string;
  weight?: string;
  splash?: {
    title: Title;
    subtitle?: Title;
    cta?: {
      text?: string;
      variant?:
        | ButtonVariations.SECONDARY
        | ButtonVariations.TERTIARY
        | ButtonVariations.BANNER;
      href?: string;
    };
    background: Image;
    titleImage?: {
      size?: Sizes;
      image: Image;
    };
  };
}

export interface VariantMap {
  [id: string]: VariantProps;
}
